import InPlay from "./InPlay";

export default InPlay;